import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';


@Component({
  selector: 'data-list',
  templateUrl: './data-list.html',
  styleUrls: ['./data-list.css'],
    standalone: false
})
export class DataListComponent extends ComponentBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
